<template>
  <div class="retail">
    <!-- 头部区域 -->
    <div class="header">
      <!-- 引用header组件 -->
      <Header class="head"></Header>
      <!-- 内容区域 -->
      <div class="header-content">
        <div class="banner-content">
          <!-- 标题 -->
          <div class="banner-first-title">
            智能新零售行业解决方案
          </div>
          <!-- 副标题 -->
          <div class="banner-second-title">
            {{ bannerSecond }}
          </div>
          <!-- 申请试用 -->
          <Apply :inputName="tit" :type="type" class="applybtn"></Apply>
        </div>
        <!-- 图片,用作flex占位 -->
        <div class="banner-img"></div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="content">
      <!-- 视频区域 -->
      <div class="video-content">
        <!-- 标题 -->
        <div class="product-title">
          <!-- 图片 -->
          <div class="product-title-img">
            <img src="../assets/img/retail/project.png" alt="" />
          </div>
        </div>
        <!-- 左侧视频 -->
        <Video :mp="mp" :poster="poster" class="video"></Video>
      </div>
      <!-- 业务 -->
      <div class="business w">
        <!-- 标题 -->
        <div class="business-tit">
          多场景赋能业务
        </div>
        <!-- 内容 -->
        <div class="business-content">
          <div
            class="business-item"
            v-for="(item, index) in businessList"
            :key="index"
          >
            <!-- 图片 -->
            <div class="item-img">
              <img :src="item.img" alt="" />
            </div>
            <!-- 名称 -->
            <div class="item-name">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 软硬件 -->
      <div class="soft business">
        <!-- 标题 -->
        <div class="business-tit">
          打造软硬件相结合的新颖方式
        </div>
        <!-- 内容 -->
        <div class="soft-content">
          <!-- <img src="../assets/img/retail/soft.png" alt="" /> -->
          <!-- 名称 -->
          <div class="soft-name">
            <!-- 一级标题 -->
            <div class="first">
              智能称重收银溯源电子秤
            </div>
            <!-- 方块 -->
            <div class="soft-box"></div>
            <div class="second">
              {{ softSecond }}
            </div>
          </div>
          <!-- 按钮 -->
          <div class="soft-box">
            <!-- 左侧 -->
            <div class="box-left">
              <div class="left-name">
                智能硬件
              </div>
              <div class="en">
                Intelligent hardware
              </div>
            </div>
            <!-- 右侧 -->
            <div class="box-right">
              <div class="left-name">
                配套软件
              </div>
              <div class="en">
                software kit
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 方案 -->
      <div class="scheme business w">
        <!-- 标题 -->
        <div class="business-tit">
          智慧新零售数字化运营方案
        </div>
        <!-- 内容 -->
        <div class="scheme-content">
          <div
            class="scheme-item"
            v-for="(item, index) in schemeList"
            :key="index"
          >
            <!-- 图片 -->
            <div class="item-img">
              <img :src="item.img" alt="" />
            </div>
            <!-- 名称 -->
            <div class="item-name">
              {{ item.name }}
            </div>
            <div class="item-detail">
              {{ item.detail }}
            </div>
          </div>
        </div>
      </div>
      <!-- 吸引 -->
      <div class="like business soft">
        <!-- 标题 -->
        <div class="business-tit">
          线上引流吸引周边新客
        </div>
        <!-- 内容 -->
        <div class="soft-content">
          <img src="../assets/img/retail/like.jpg" alt="" />
          <!-- 名称 -->
          <div class="content">
            <div class="item" v-for="(item, index) in likeList" :key="index">
              <div class="no">
                {{ item.no }}
              </div>
              <div class="name">
                {{ item.name }}
              </div>
              <div class="detail">
                {{ item.detail }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 价值 -->
      <div class="value business">
        <!-- 标题 -->
        <div class="business-tit">
          方案价值
        </div>
        <div class="value-content">
          <img src="../assets/img/retail/value/bg.png" alt="" width="99.99%" />
          <!-- item -->
          <div
            class="value-item"
            v-for="(item, index) in valueList"
            :key="index"
          >
            <!-- 图片 -->
            <div class="value-item-img">
              <img :src="item.img" alt="" />
              <!-- 内容 -->
              <div class="value-intro">
                <div class="value-en">{{ item.en }}</div>
                <div class="value-name">
                  {{ item.name }}
                </div>
                <div class="value-detail">{{ item.detail }}</div>
                <div class="value-box"></div>
              </div>
            </div>
            <!-- 右侧 -->
            <div class="item-box">
              <div
                class="item-box-item"
                v-for="(item2, index2) in item.children"
                :key="index2"
              >
                <img :src="item2.img" alt="" />
                <div class="item2-name">{{ item2.name }}</div>
                <div class="item2-detail">{{ item2.detail }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 试用 -->
      <Solution :inputName="apply" :type="type"></Solution>
    </div>
  </div>
</template>

<script>
// 引用申请试用和头部组件
import Apply from '../components/apply.vue'
import Header from '../components/header.vue'
import Solution from '../components/solution.vue'
import Video from '../components/video.vue'
export default {
  components: {
    Apply,
    Header,
    Solution,
    Video
  },
  data() {
    return {
      bannerSecond:
        '通过营销、硬件收银、配送、会员等功能，赋能门店线上获客、客户留存、及时配送的能力，实现线上线下相结合，让零售行业产品流通更高效，有效减少交易成本，迅速的增强品牌效应，扩大销售渠道。',
      tit: '方案咨询',
      apply: '新零售申请试用',
      // 业务
      businessList: [
        {
          name: '新零售到店',
          img: require('../assets/img/retail/business/07.png')
        },
        {
          name: '智慧收银',
          img: require('../assets/img/retail/business/02.png')
        },
        {
          name: '连锁加盟',
          img: require('../assets/img/retail/business/03.png')
        },
        {
          name: '客户管理',
          img: require('../assets/img/retail/business/04.png')
        },
        {
          name: '会员营销',
          img: require('../assets/img/retail/business/05.png')
        },
        {
          name: '拼团秒杀',
          img: require('../assets/img/retail/business/06.png')
        },
        {
          name: '订货商城',
          img: require('../assets/img/retail/business/07.png')
        },
        {
          name: '直播带货',
          img: require('../assets/img/retail/business/08.png')
        }
      ],
      softSecond:
        '实现智能称重、收银，可打印溯源票据，此外，还搭载智能AI识别功能，配合自主研发的软件系统，便于商户操作',
      // 方案
      schemeList: [
        {
          name: '统一商品库存管理',
          detail:
            '仓库信息管理，商品出入库，盘点调拨，库存同步策略，全渠道数据打通，品牌商统一管控商品、库存、订单，协助品牌商掌握全渠道。',
          img: require('../assets/img/retail/scheme/01.png')
        },
        {
          name: '快速开店',
          detail: 'B2B2C/云店/小程序/H5',
          img: require('../assets/img/retail/scheme/02.png')
        },
        {
          name: '商品智能运营',
          detail:
            '通过检测与分析全渠道销售数据，进行销售预测，及时进行库存预警A。',
          img: require('../assets/img/retail/scheme/03.png')
        },
        {
          name: '消费者精细化运营',
          detail:
            '通过建立360°客户画像，对客户群进行精细化划分，针对精准客群制定营销任务，自动匹配运营策略',
          img: require('../assets/img/retail/scheme/04.png')
        },
        {
          name: '直播带货',
          detail: '采用新颖的带货方式，帮助商家精准搭建线上购物环境',
          img: require('../assets/img/retail/scheme/05.png')
        },
        {
          name: '定制化服务',
          detail: '满足用户的个性化需求',
          img: require('../assets/img/retail/scheme/06.png')
        }
      ],
      // 吸引
      likeList: [
        {
          no: '01',
          name: '小程序LBS定位',
          detail:
            '通过LBS定位获取用户的当前区域自动推荐周边精准定位选择，便于用户操作'
        },
        {
          no: '02',
          name: '店铺推荐'
        },
        {
          no: '03',
          name: '限时折扣'
        },
        {
          no: '04',
          name: '优惠红包'
        },
        {
          no: '05',
          name: '会员积分'
        }
      ],
      // 价值
      valueList: [
        {
          name: '对于商户',
          en: 'Business',
          detail: '为商户赋能，帮助商户更好卖货',
          img: require('../assets/img/retail/value/02.png'),
          children: [
            {
              name: '门店软硬件支撑',
              detail: '完善的软硬件设施支撑线下业务开展',
              img: require('../assets/img/retail/value/11.png')
            },
            {
              name: '线上商城',
              detail: '一键开店，迅速扩展销售渠道',
              img: require('../assets/img/retail/value/12.png')
            },
            {
              name: '会员营销',
              detail: '灵活的激励模式吸引更多消费者消费',
              img: require('../assets/img/retail/value/13.png')
            }
          ]
        },
        {
          name: '对于品牌',
          en: 'Brand',
          detail: '实现全平台数字化经营，驱动平台智能发展',
          img: require('../assets/img/retail/value/01.png'),
          children: [
            {
              name: '一体化管控',
              detail: '全渠道数据打通商品，一体化管控',
              img: require('../assets/img/retail/value/21.png')
            },
            {
              name: '招商吸引',
              detail: '多模式分销吸引更多分销商入住',
              img: require('../assets/img/retail/value/22.png')
            },
            {
              name: '共享库存',
              detail: '线上线下库存数据一体化管理',
              img: require('../assets/img/retail/value/23.png')
            }
          ]
        }
      ],
      type: '4',
      mp:
        'https://file.agricultural.fameveg.com/file/upload/null/2021-07-22/921943f8731e43ec95c714d4d80b3a13.mp4',
      poster:
        'https://file.agricultural.fameveg.com/file/upload/null/2021-07-22/34db31061d3244898a6003b2ae9cfeed.png'
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.retail {
  height: 100%;
  background: #f7f7f7;
}
// 头部区域
.header {
  height: 800px;
  width: 100%;
  background: url(../assets/img/retail/banner.jpg) center no-repeat;
  background-size: cover;
  color: #fff;
  font-size: 22px;
  .header-content {
    display: flex;
    justify-content: center;
    .banner-content {
      width: 800px;
      color: #ffffff;
      padding: 43px;
      .banner-first-title {
        margin-top: 70px;
        font-size: 50px;
      }
      .banner-second-title {
        margin-top: 50px;
        font-size: 22px;
        margin-bottom: 60px;
        width: 500px;
      }
      .applybtn {
        position: relative;
        top: 50px;
        left: -150px;
      }
    }
    .banner-img {
      width: 600px;
    }
  }
}
// 内容
.content {
  .video-content {
    margin-top: 100px;
    .product-title {
      width: 191px;
      margin: 0 auto;
    }
    .video {
      width: 900px;
      margin: 100px auto;
    }
  }
  // 业务
  .business {
    height: 600px;
    .business-tit {
      margin-top: 100px;
      text-align: center;
      font-size: 40px;
      color: #333333;
    }
    .business-content {
      margin-top: 100px;
      display: flex;
      flex-wrap: wrap;
      .business-item {
        width: 308px;
        height: 150px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px;
        border-radius: 10px;
        .item-img {
          width: 80px;
          height: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item-name {
          flex: 1;
          text-align: center;
          font-size: 24px;
          font-weight: 300;
          color: #333333;
        }
      }
      .business-item:hover {
        background-color: #00cf61;
        box-shadow: 5px 0px 10px #00cf61;
        .item-name {
          color: #fff;
        }
      }
    }
  }
  // 软硬件
  .soft {
    height: 800px;
    .soft-content {
      width: 100%;
      height: 600px;
      margin-top: 100px;
      position: relative;
      background: url(../assets/img/retail/soft.png) center no-repeat;
      background-size: cover;
      img {
        width: 100%;
        height: 600px;
      }
      .soft-name {
        position: absolute;
        top: 138px;
        left: 12%;
        color: #ffffff;
        .first {
          font-size: 48px;
          font-weight: 300;
        }
        .soft-box {
          position: absolute;
          top: 15%;
          left: 55%;
          width: 259px;
          height: 37px;
          background: #f7f7f7;
          opacity: 0.2;
        }
        .second {
          margin-top: 40px;
          width: 500px;
          font-size: 22px;
        }
      }
      .soft-box {
        position: absolute;
        bottom: 20px;
        width: 600px;
        left: 30%;
        height: 200px;
        display: flex;
        .box-left,
        .box-right {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 300px;
          background-color: #000;
          color: #fff;
          .en {
            margin-top: 20px;
          }
        }
        .box-right {
          width: 300px;
          background: #ffffff;
          opacity: 0.5;
          color: #333;
        }
      }
    }
  }
  // 方案
  .scheme {
    height: 1200px;
    .scheme-content {
      margin-top: 120px;
      display: flex;
      flex-wrap: wrap;
      .scheme-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 417px;
        height: 450px;
        background: #ffffff;
        margin: 22px;
        padding: 0 38px;
        box-sizing: border-box;
        .item-name {
          margin-top: 40px;
          font-size: 28px;
          font-weight: bold;
          color: #333333;
        }
        .item-detail {
          margin-top: 18px;
          font-size: 20px;
          font-weight: 300;
          color: #999999;
        }
      }
    }
  }
  // 吸引
  .like {
    .content {
      position: absolute;
      top: 20px;
      display: flex;
      width: 100%;
      height: 90%;
      .item {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        border-right: 1px solid #ffffff;
        padding: 0 60px;
        .no {
          font-size: 60px;
          font-weight: 500;
        }
        .name {
          margin-top: 44px;
          font-size: 36px;
          font-weight: 300;
        }
        .detail {
          margin-top: 30px;
          font-size: 20px;
          font-weight: 300;
          color: #cdcdcd;
        }
      }
    }
  }
  // 价值
  .value {
    width: 100%;
    height: 1500px;
    .value-content {
      position: relative;
      margin-top: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .value-item {
        position: absolute;
        top: 700px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row-reverse;
        .value-item-img {
          position: relative;
          .value-intro {
            position: absolute;
            top: 0;
            height: 500px;
            width: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            margin-left: 10%;
            .value-en {
              font-size: 100px;
              font-weight: bold;
              line-height: 22px;
              opacity: 0.1;
            }
            .value-name {
              font-size: 48px;
              font-weight: bold;
            }
            .value-detail {
              margin-top: 30px;
              font-size: 24px;
            }
            .value-box {
              margin-top: 40px;
              width: 168px;
              height: 9px;
              background: #ffffff;
            }
          }
        }
        .item-box {
          display: flex;
          width: 736px;
          height: 283px;
          background: #ffffff;
          box-shadow: 11px 10px 18px 2px rgba(148, 148, 148, 0.1);
          border-radius: 10px;
          margin-left: -30px;
          margin-right: -30px;
          z-index: 999;
          .item-box-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 30%;
            margin: 0 20px;
            .item2-name {
              margin-top: 20px;
              font-size: 22px;
              color: #333333;
            }
            .item2-detail {
              margin-top: 20px;
              font-size: 18px;
              color: #999999;
            }
          }
        }
      }
      .value-item:nth-child(2) {
        top: 100px;
        flex-direction: row;
      }
    }
  }
}
.w {
  width: 1400px;
  margin: 0 auto;
}
</style>
